/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Sync_Changes_Status_ErrorInputs */



/**
* | output |
* | --- |
* | "Error: {error}" |
*
* @param {Sync_Changes_Status_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_status_error = /** @type {((inputs: Sync_Changes_Status_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Status_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`错误：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`エラー: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
});